import { EntityRepository } from '@record-it-npm/synchro-client';
import { EntityName } from 'record-it-time-common/EntityName';
import { AppSynchronizationEnvironmentTypes } from '../../../AppSynchronizationEnvironmentTypes';
import { AppEntityManagerEntityTypesByEntityName } from '../AppEntityManagerEntityTypesByEntityName';
export class UserRepository extends EntityRepository<AppSynchronizationEnvironmentTypes, EntityName.User, AppEntityManagerEntityTypesByEntityName> {
  public create(): never {
    throw new Error("Can't create a User via the synchronization");
  }
}